module.exports = __webpack_public_path__ + "img/photo_220270567_1.cae13dfb.png";